// removed by extract-text-webpack-plugin
module.exports = {"main":"time-display-main--2-tly","status-ok":"time-display-status-ok--qbgFK","status-warning":"time-display-status-warning--3BgBP","status-problem":"time-display-status-problem--2SQ8s","status-disconnected":"time-display-status-disconnected--2OoK7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimeDisplay/time-display.scss
// module id = 2689
// module chunks = 4